import { ApiEndpoints } from "@shared/api/api-endpoints";
import { authApiClient, consumerApiClient, cxApiClient } from "@shared/api/clients/apiClientFactory";

// Add your feature-specific API calls here
export const AuthApi = {
  // Get Utility Info - GET
  getUtilityInfo: async (params: { tenant_alias: string; utility_alias: string }): Promise<any> => {
    const response = await authApiClient.get(
      `utility-info/?tenant_alias=${params.tenant_alias}&utility_alias=${params.utility_alias}`
    );
    return response.data;
  },

  // Consumer Web Login - POST
  consumerWebLogin: async (payload: any): Promise<any> => {
    const response = await consumerApiClient.post(`login/`, payload);
    return response.data;
  },
  
  generateOtp: async (payload: { email: string; remote_utility_id: number }): Promise<any> => {
    const response = await consumerApiClient.post(`generate-otp/`, payload);
    return response.data;
  },
  verifyOtp: async (payload): Promise<any> => {
    const response = await consumerApiClient.post(`verify-otp/`, payload);
    return response.data;
  },
  
  getConsumerDetail: async (params: { remote_utility_id: number; consumer_no: string }): Promise<any> => {
    const response = await consumerApiClient.get(
      `consumer-detail/?remote_utility_id=${params.remote_utility_id}&consumer_no=${params.consumer_no}`,
      {
        headers: {
          Authorization: 'Bearer q*#9p!mZ3v@8nXy_T5k2JwR^4cDb6gH-'
        }
      }
    );
    return response.data;
  },

  resetPassword:async(payload)=>{
    const response = await consumerApiClient.post(`reset-password/`, payload);
    return response.data;
  },
};

export const getNscResponseTimeConfiguration = async (
  remote_utility_id: string
): Promise<any> => {
  try {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "nsc-connection-configuration",
      (query) => {
        query.push("remote_utility_id", remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    const result = response.data.result || response.data;
    // :white_check_mark: Automatically store in localStorage after successful fetch
    if (result) {
      localStorage.setItem("NSC-Configuration", JSON.stringify(result));
      console.log(":white_check_mark: NSC configuration saved to localStorage");
    }
    return result;
  } catch (error) {
    console.error(":x: Failed to fetch NSC configuration:", error);
    throw error; // rethrow so hook/query can handle it
  }
};
